
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4OFpt", function(module, exports) {

$parcel$export(module.exports, "attachToolReview", () => $381bf416ae3d8c1c$export$39d9eef7aef411a);
$parcel$export(module.exports, "initToolReviews", () => $381bf416ae3d8c1c$export$3c7f094803ce8e2b);
// Firebase (app, App Check, Firestore) pesa piu' di 200 KB e serve solo quando
// il widget viene davvero usato: si carica al primo utilizzo, non con la pagina.

var $eZ0we = parcelRequire("eZ0we");
let $381bf416ae3d8c1c$var$firestorePromise = null;


function $381bf416ae3d8c1c$var$caricaFirestore() {
    if (!$381bf416ae3d8c1c$var$firestorePromise) $381bf416ae3d8c1c$var$firestorePromise = Promise.all([
        (parcelRequire("cet9q")),
        (parcelRequire("gQnFK"))
    ]).then(([firestore, { firebaseInit: firebaseInit }])=>({
            firestore: firestore,
            firebaseInit: firebaseInit
        }));
    return $381bf416ae3d8c1c$var$firestorePromise;
}
// Dizionario locale del widget recensioni (chiavi = stringhe italiane).
(0, $eZ0we.registerTranslations)({
    'Nascondi recensione per 24 ore': 'Hide the review prompt for 24 hours',
    'questo tool': 'this tool',
    'Raccontaci la tua esperienza': 'Tell us about your experience',
    "Com'\xe8 andata con {tool}? La tua opinione ci aiuta a migliorare l'esperienza.": 'How did it go with {tool}? Your feedback helps us improve the experience.',
    'Valuta {tool} da 1 a 5 stelle': 'Rate {tool} from 1 to 5 stars',
    '{n} stelle': '{n} stars',
    'Chiudi recensione': 'Close review',
    'Grazie per il voto': 'Thanks for your rating',
    'Vuoi aggiungere una recensione?': 'Would you like to add a review?',
    'Il tuo nome': 'Your name',
    'Es. Marco': 'E.g. Sarah',
    "Opzionale: se lasci vuoto, useremo \u201CAnonimo\u201D.": "Optional: if you leave it blank, we will use \u201CAnonymous\u201D.",
    'Recensione breve': 'Short review',
    '(opzionale)': '(optional)',
    "Cosa ti \xe8 piaciuto? Cosa possiamo migliorare?": 'What did you like? What could we improve?',
    'Massimo {n} caratteri.': 'Maximum {n} characters.',
    "Pi\xf9 tardi": 'Maybe later',
    'Conferma recensione': 'Submit review',
    'Ci dispiace': 'Sorry to hear that',
    'Cosa non ha funzionato?': 'What went wrong?',
    'Raccontaci il problema': 'Tell us what happened',
    '(obbligatorio)': '(required)',
    'Es. il calcolo non torna, la pagina non si carica, manca una funzione...': 'E.g. the numbers look wrong, the page does not load, a feature is missing...',
    'Annulla': 'Cancel',
    'Invia voto e feedback': 'Send rating and feedback',
    'Hai selezionato 1 stella.': 'You selected 1 star.',
    'Hai selezionato {n} stelle.': 'You selected {n} stars.',
    'Abbiamo mantenuto il tuo voto precedente.': 'We kept your previous rating.',
    "Voto non registrato. Se cambi idea, raccontaci cosa \xe8 andato storto.": 'Rating not saved. If you change your mind, tell us what went wrong.',
    'Anonimo': 'Anonymous',
    'Raccontaci cosa non ha funzionato per registrare il voto.': 'Tell us what went wrong to register your rating.',
    'Salvataggio del voto in corso...': 'Saving your rating...',
    'Voto salvato. Puoi aggiungere una recensione se vuoi.': 'Rating saved. You can add a review if you like.',
    'Non siamo riusciti a salvare il voto. Riprova tra poco.': 'We could not save your rating. Please try again shortly.',
    'Scrivi almeno qualche parola sul problema (minimo {n} caratteri).': 'Please write at least a few words about the problem (minimum {n} characters).',
    'Salvataggio in corso...': 'Saving...',
    'Grazie, recensione salvata.': 'Thanks, your review has been saved.',
    'Recensione salvata. Grazie!': 'Review saved. Thank you!',
    'Non siamo riusciti a salvare la recensione. Riprova tra poco.': 'We could not save your review. Please try again shortly.',
    "Hai gi\xe0 lasciato un voto. Puoi aggiornarlo quando vuoi.": 'You have already left a rating. You can update it anytime.',
    'Recensioni temporaneamente non disponibili.': 'Reviews are temporarily unavailable.'
});
const $381bf416ae3d8c1c$var$COLLECTION_NAME = 'toolReviews';
const $381bf416ae3d8c1c$var$GA_MEASUREMENT_ID = 'G-HHXEQQP7MF';
const $381bf416ae3d8c1c$var$LOCAL_CLIENT_KEY = 'stipendee_tool_review_client_id';
const $381bf416ae3d8c1c$var$DISMISSED_KEY_PREFIX = 'stipendee_tool_review_dismissed_until';
const $381bf416ae3d8c1c$var$MAX_COMMENT_LENGTH = 1000;
const $381bf416ae3d8c1c$var$MAX_DISPLAY_NAME_LENGTH = 60;
const $381bf416ae3d8c1c$var$DISMISS_DURATION_MS = 86400000;
const $381bf416ae3d8c1c$var$LOW_RATING_THRESHOLD = 2;
const $381bf416ae3d8c1c$var$LOW_RATING_MIN_COMMENT_LENGTH = 10;
let $381bf416ae3d8c1c$var$modalElements = null;
let $381bf416ae3d8c1c$var$activeWidget = null;
const $381bf416ae3d8c1c$var$clampRating = (value)=>{
    const rating = Number.parseInt(value, 10);
    if (!Number.isInteger(rating)) return null;
    return Math.max(1, Math.min(5, rating));
};
const $381bf416ae3d8c1c$var$escapeHtml = (value)=>String(value).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
async function $381bf416ae3d8c1c$var$sha256(value) {
    if (!crypto?.subtle) {
        let hash = 0;
        const input = String(value);
        for(let index = 0; index < input.length; index += 1){
            hash = (hash << 5) - hash + input.charCodeAt(index);
            hash |= 0;
        }
        return `fallback-${Math.abs(hash).toString(16)}`;
    }
    const encoder = new TextEncoder();
    const data = encoder.encode(value);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hashBuffer)).map((byte)=>byte.toString(16).padStart(2, '0')).join('');
}
function $381bf416ae3d8c1c$var$getLocalClientId() {
    try {
        let clientId = localStorage.getItem($381bf416ae3d8c1c$var$LOCAL_CLIENT_KEY);
        if (!clientId) {
            clientId = crypto?.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
            localStorage.setItem($381bf416ae3d8c1c$var$LOCAL_CLIENT_KEY, clientId);
        }
        return clientId;
    } catch (error) {
        return `session-${Date.now()}-${Math.random()}`;
    }
}
function $381bf416ae3d8c1c$var$getGaClientId() {
    return new Promise((resolve)=>{
        if (typeof window.gtag !== 'function') {
            resolve(null);
            return;
        }
        const timeout = window.setTimeout(()=>resolve(null), 1200);
        window.gtag('get', $381bf416ae3d8c1c$var$GA_MEASUREMENT_ID, 'client_id', (clientId)=>{
            window.clearTimeout(timeout);
            resolve(clientId || null);
        });
    });
}
async function $381bf416ae3d8c1c$var$getClientIdentity() {
    const gaClientId = await $381bf416ae3d8c1c$var$getGaClientId();
    const source = gaClientId ? 'ga' : 'local';
    const rawClientId = gaClientId || $381bf416ae3d8c1c$var$getLocalClientId();
    const clientIdHash = await $381bf416ae3d8c1c$var$sha256(rawClientId);
    return {
        clientIdHash: clientIdHash,
        source: source
    };
}
async function $381bf416ae3d8c1c$var$getDb() {
    const { firestore: firestore, firebaseInit: firebaseInit } = await $381bf416ae3d8c1c$var$caricaFirestore();
    const { app: app } = firebaseInit();
    return {
        db: firestore.getFirestore(app),
        firestore: firestore
    };
}
function $381bf416ae3d8c1c$var$getDismissedKey(toolSlug) {
    return `${$381bf416ae3d8c1c$var$DISMISSED_KEY_PREFIX}:${toolSlug}`;
}
function $381bf416ae3d8c1c$var$isDismissed(toolSlug) {
    try {
        const dismissedUntil = Number.parseInt(localStorage.getItem($381bf416ae3d8c1c$var$getDismissedKey(toolSlug)), 10);
        return Number.isFinite(dismissedUntil) && dismissedUntil > Date.now();
    } catch (error) {
        return false;
    }
}
function $381bf416ae3d8c1c$var$dismissWidget(widget) {
    try {
        localStorage.setItem($381bf416ae3d8c1c$var$getDismissedKey(widget.toolSlug), String(Date.now() + $381bf416ae3d8c1c$var$DISMISS_DURATION_MS));
    } catch (error) {
        console.warn('Impossibile salvare la chiusura recensioni', error);
    }
    widget.container.hidden = true;
    widget.container.innerHTML = '';
}
function $381bf416ae3d8c1c$var$buildWidget(container) {
    const toolName = container.dataset.toolName || (0, $eZ0we.t)('questo tool');
    const hideDismiss = container.dataset.toolReviewHideDismiss === 'true';
    const dismissButton = hideDismiss ? '' : `
    <button type="button" class="tool-review__dismiss" aria-label="${(0, $eZ0we.t)('Nascondi recensione per 24 ore')}">
      <i class="ph ph-x" aria-hidden="true"></i>
    </button>
  `;
    container.classList.add('tool-review');
    container.innerHTML = `
    ${dismissButton}
    <div class="tool-review__copy">
      <h2>${(0, $eZ0we.t)('Raccontaci la tua esperienza')}</h2>
      <p>${(0, $eZ0we.t)("Com'\xe8 andata con {tool}? La tua opinione ci aiuta a migliorare l'esperienza.", {
        tool: $381bf416ae3d8c1c$var$escapeHtml(toolName)
    })}</p>
    </div>
    <div class="tool-review__stars" role="radiogroup" aria-label="${(0, $eZ0we.t)('Valuta {tool} da 1 a 5 stelle', {
        tool: $381bf416ae3d8c1c$var$escapeHtml(toolName)
    })}"></div>
    <p class="tool-review__status" aria-live="polite"></p>
  `;
    const stars = container.querySelector('.tool-review__stars');
    for(let rating = 1; rating <= 5; rating += 1){
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'tool-review__star';
        button.dataset.rating = String(rating);
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', 'false');
        button.setAttribute('aria-label', (0, $eZ0we.t)('{n} stelle', {
            n: rating
        }));
        button.textContent = "\u2605";
        stars.appendChild(button);
    }
}
function $381bf416ae3d8c1c$var$setStatus(widget, message, type = '') {
    if (!widget.statusEl) return;
    widget.statusEl.textContent = message;
    widget.statusEl.dataset.status = type;
}
function $381bf416ae3d8c1c$var$updateStars(widget, rating) {
    widget.rating = rating;
    widget.starButtons.forEach((button)=>{
        const starRating = Number.parseInt(button.dataset.rating, 10);
        const isSelected = starRating <= rating;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-checked', String(starRating === rating));
    });
}
function $381bf416ae3d8c1c$var$getCommentValue() {
    const value = $381bf416ae3d8c1c$var$modalElements?.comment?.value || '';
    return value.slice(0, $381bf416ae3d8c1c$var$MAX_COMMENT_LENGTH).trim();
}
function $381bf416ae3d8c1c$var$getDisplayNameValue() {
    const value = $381bf416ae3d8c1c$var$modalElements?.displayName?.value || '';
    return value.slice(0, $381bf416ae3d8c1c$var$MAX_DISPLAY_NAME_LENGTH).trim();
}
function $381bf416ae3d8c1c$var$updateCommentCounter() {
    if (!$381bf416ae3d8c1c$var$modalElements?.counter || !$381bf416ae3d8c1c$var$modalElements?.comment) return;
    const length = $381bf416ae3d8c1c$var$modalElements.comment.value.length;
    $381bf416ae3d8c1c$var$modalElements.counter.textContent = `${length}/${$381bf416ae3d8c1c$var$MAX_COMMENT_LENGTH}`;
}
function $381bf416ae3d8c1c$var$ensureModal() {
    if ($381bf416ae3d8c1c$var$modalElements) return $381bf416ae3d8c1c$var$modalElements;
    const modal = document.createElement('div');
    modal.className = 'tool-review-modal';
    modal.id = 'toolReviewModal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = `
    <div class="tool-review-modal__backdrop" data-tool-review-close></div>
    <div class="tool-review-modal__panel" role="dialog" aria-modal="true" aria-labelledby="toolReviewModalTitle">
      <button type="button" class="tool-review-modal__close" data-tool-review-close aria-label="${(0, $eZ0we.t)('Chiudi recensione')}">
        <i class="ph ph-x" aria-hidden="true"></i>
      </button>
      <p class="tool-review__eyebrow">${(0, $eZ0we.t)('Grazie per il voto')}</p>
      <h2 id="toolReviewModalTitle">${(0, $eZ0we.t)('Vuoi aggiungere una recensione?')}</h2>
      <p class="tool-review-modal__rating"></p>
      <label class="tool-review-modal__field" for="toolReviewDisplayName">
        <span>${(0, $eZ0we.t)('Il tuo nome')}</span>
        <input id="toolReviewDisplayName" type="text" maxlength="${$381bf416ae3d8c1c$var$MAX_DISPLAY_NAME_LENGTH}" placeholder="${(0, $eZ0we.t)('Es. Marco')}">
        <small>${(0, $eZ0we.t)("Opzionale: se lasci vuoto, useremo \u201CAnonimo\u201D.")}</small>
      </label>
      <label class="tool-review-modal__field" for="toolReviewComment">
        <span class="tool-review-modal__comment-label">${(0, $eZ0we.t)('Recensione breve')} <small>${(0, $eZ0we.t)('(opzionale)')}</small></span>
        <textarea id="toolReviewComment" rows="5" maxlength="${$381bf416ae3d8c1c$var$MAX_COMMENT_LENGTH}" placeholder="${(0, $eZ0we.t)("Cosa ti \xe8 piaciuto? Cosa possiamo migliorare?")}"></textarea>
      </label>
      <div class="tool-review-modal__meta">
        <span>${(0, $eZ0we.t)('Massimo {n} caratteri.', {
        n: $381bf416ae3d8c1c$var$MAX_COMMENT_LENGTH
    })}</span>
        <span class="tool-review-modal__counter">0/${$381bf416ae3d8c1c$var$MAX_COMMENT_LENGTH}</span>
      </div>
      <p class="tool-review-modal__status" aria-live="polite"></p>
      <div class="tool-review-modal__actions">
        <button type="button" class="myButton white-button" data-tool-review-close>
          <span class="tool-review-modal__cancel-label">${(0, $eZ0we.t)("Pi\xf9 tardi")}</span>
        </button>
        <button type="button" class="myButton" data-tool-review-submit>
          <span class="button-text">${(0, $eZ0we.t)('Conferma recensione')}</span>
        </button>
      </div>
    </div>
  `;
    document.body.appendChild(modal);
    $381bf416ae3d8c1c$var$modalElements = {
        modal: modal,
        eyebrow: modal.querySelector('.tool-review__eyebrow'),
        title: modal.querySelector('#toolReviewModalTitle'),
        ratingText: modal.querySelector('.tool-review-modal__rating'),
        commentLabel: modal.querySelector('.tool-review-modal__comment-label'),
        displayName: modal.querySelector('#toolReviewDisplayName'),
        comment: modal.querySelector('#toolReviewComment'),
        counter: modal.querySelector('.tool-review-modal__counter'),
        status: modal.querySelector('.tool-review-modal__status'),
        cancelLabel: modal.querySelector('.tool-review-modal__cancel-label'),
        submit: modal.querySelector('[data-tool-review-submit]'),
        submitLabel: modal.querySelector('[data-tool-review-submit] .button-text')
    };
    modal.querySelectorAll('[data-tool-review-close]').forEach((button)=>{
        button.addEventListener('click', $381bf416ae3d8c1c$var$closeModal);
    });
    $381bf416ae3d8c1c$var$modalElements.comment.addEventListener('input', ()=>{
        $381bf416ae3d8c1c$var$updateCommentCounter();
        $381bf416ae3d8c1c$var$updateSubmitState();
    });
    $381bf416ae3d8c1c$var$modalElements.submit.addEventListener('click', $381bf416ae3d8c1c$var$handleModalSubmit);
    document.addEventListener('keydown', (event)=>{
        if (event.key === 'Escape' && modal.classList.contains('is-open')) $381bf416ae3d8c1c$var$closeModal();
    });
    return $381bf416ae3d8c1c$var$modalElements;
}
function $381bf416ae3d8c1c$var$updateSubmitState() {
    if (!$381bf416ae3d8c1c$var$modalElements) return;
    const needsComment = Boolean($381bf416ae3d8c1c$var$activeWidget?.pendingLowRating);
    $381bf416ae3d8c1c$var$modalElements.submit.disabled = needsComment && $381bf416ae3d8c1c$var$getCommentValue().length < $381bf416ae3d8c1c$var$LOW_RATING_MIN_COMMENT_LENGTH;
}
function $381bf416ae3d8c1c$var$configureModalMode(elements, isLowRating) {
    elements.eyebrow.textContent = isLowRating ? (0, $eZ0we.t)('Ci dispiace') : (0, $eZ0we.t)('Grazie per il voto');
    elements.title.textContent = isLowRating ? (0, $eZ0we.t)('Cosa non ha funzionato?') : (0, $eZ0we.t)('Vuoi aggiungere una recensione?');
    elements.commentLabel.innerHTML = isLowRating ? `${(0, $eZ0we.t)('Raccontaci il problema')} <small>${(0, $eZ0we.t)('(obbligatorio)')}</small>` : `${(0, $eZ0we.t)('Recensione breve')} <small>${(0, $eZ0we.t)('(opzionale)')}</small>`;
    elements.comment.placeholder = isLowRating ? (0, $eZ0we.t)('Es. il calcolo non torna, la pagina non si carica, manca una funzione...') : (0, $eZ0we.t)("Cosa ti \xe8 piaciuto? Cosa possiamo migliorare?");
    elements.cancelLabel.textContent = isLowRating ? (0, $eZ0we.t)('Annulla') : (0, $eZ0we.t)("Pi\xf9 tardi");
    elements.submitLabel.textContent = isLowRating ? (0, $eZ0we.t)('Invia voto e feedback') : (0, $eZ0we.t)('Conferma recensione');
}
function $381bf416ae3d8c1c$var$openModal(widget) {
    const elements = $381bf416ae3d8c1c$var$ensureModal();
    $381bf416ae3d8c1c$var$activeWidget = widget;
    $381bf416ae3d8c1c$var$configureModalMode(elements, Boolean(widget.pendingLowRating));
    elements.ratingText.textContent = widget.rating === 1 ? (0, $eZ0we.t)('Hai selezionato 1 stella.') : (0, $eZ0we.t)('Hai selezionato {n} stelle.', {
        n: widget.rating
    });
    const isAnonymousName = widget.displayName === 'Anonimo' || widget.displayName === 'Anonymous';
    elements.displayName.value = isAnonymousName ? '' : widget.displayName || '';
    elements.comment.value = widget.comment || '';
    elements.status.textContent = '';
    $381bf416ae3d8c1c$var$updateCommentCounter();
    $381bf416ae3d8c1c$var$updateSubmitState();
    elements.modal.classList.add('is-open');
    elements.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tool-review-modal-open');
    window.setTimeout(()=>elements.comment.focus(), 0);
}
function $381bf416ae3d8c1c$var$closeModal() {
    if (!$381bf416ae3d8c1c$var$modalElements) return;
    const widget = $381bf416ae3d8c1c$var$activeWidget;
    $381bf416ae3d8c1c$var$modalElements.modal.classList.remove('is-open');
    $381bf416ae3d8c1c$var$modalElements.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tool-review-modal-open');
    $381bf416ae3d8c1c$var$activeWidget = null;
    if (widget?.pendingLowRating) {
        widget.pendingLowRating = false;
        $381bf416ae3d8c1c$var$updateStars(widget, widget.savedRating || 0);
        $381bf416ae3d8c1c$var$setStatus(widget, widget.savedRating ? (0, $eZ0we.t)('Abbiamo mantenuto il tuo voto precedente.') : (0, $eZ0we.t)("Voto non registrato. Se cambi idea, raccontaci cosa \xe8 andato storto."), '');
    }
}
async function $381bf416ae3d8c1c$var$saveReview(widget, { status: status }) {
    const rating = $381bf416ae3d8c1c$var$clampRating(widget.rating);
    if (!rating || !widget.docRef) return;
    const comment = status === 'completed' ? $381bf416ae3d8c1c$var$getCommentValue() : widget.comment || '';
    const displayNameInput = status === 'completed' ? $381bf416ae3d8c1c$var$getDisplayNameValue() : widget.displayName || '';
    const displayName = displayNameInput || (0, $eZ0we.t)('Anonimo');
    const timestamp = new Date().toISOString();
    const payload = {
        toolSlug: widget.toolSlug,
        toolName: widget.toolName,
        rating: rating,
        comment: comment,
        displayName: displayName,
        isAnonymous: !displayNameInput,
        lang: (0, $eZ0we.PAGE_LANG),
        clientIdHash: widget.clientIdHash,
        clientIdSource: widget.clientIdSource,
        status: status,
        pageUrl: window.location.href,
        baseUrl: window.location.origin,
        pageTitle: document.title,
        userAgent: navigator.userAgent,
        timestamp: timestamp,
        updatedAt: timestamp
    };
    if (!widget.hasExistingReview) payload.createdAt = timestamp;
    await widget.firestore.setDoc(widget.docRef, payload, {
        merge: true
    });
    widget.hasExistingReview = true;
    widget.comment = comment;
    widget.displayName = displayName;
    widget.savedRating = rating;
    widget.pendingLowRating = false;
}
async function $381bf416ae3d8c1c$var$handleStarClick(widget, rating) {
    if (!await widget.connect()) return;
    const parsedRating = $381bf416ae3d8c1c$var$clampRating(rating);
    if (!parsedRating) return;
    $381bf416ae3d8c1c$var$updateStars(widget, parsedRating);
    if (parsedRating <= $381bf416ae3d8c1c$var$LOW_RATING_THRESHOLD) {
        widget.pendingLowRating = true;
        $381bf416ae3d8c1c$var$setStatus(widget, (0, $eZ0we.t)('Raccontaci cosa non ha funzionato per registrare il voto.'), '');
        $381bf416ae3d8c1c$var$openModal(widget);
        return;
    }
    widget.pendingLowRating = false;
    $381bf416ae3d8c1c$var$setStatus(widget, (0, $eZ0we.t)('Salvataggio del voto in corso...'), '');
    $381bf416ae3d8c1c$var$openModal(widget);
    try {
        await $381bf416ae3d8c1c$var$saveReview(widget, {
            status: 'rating_only'
        });
        $381bf416ae3d8c1c$var$setStatus(widget, (0, $eZ0we.t)('Voto salvato. Puoi aggiungere una recensione se vuoi.'), 'success');
    } catch (error) {
        console.warn('Salvataggio recensione fallito', error);
        $381bf416ae3d8c1c$var$setStatus(widget, (0, $eZ0we.t)('Non siamo riusciti a salvare il voto. Riprova tra poco.'), 'error');
    }
}
async function $381bf416ae3d8c1c$var$handleModalSubmit() {
    if (!$381bf416ae3d8c1c$var$activeWidget) return;
    if ($381bf416ae3d8c1c$var$activeWidget.pendingLowRating && $381bf416ae3d8c1c$var$getCommentValue().length < $381bf416ae3d8c1c$var$LOW_RATING_MIN_COMMENT_LENGTH) {
        $381bf416ae3d8c1c$var$modalElements.status.textContent = (0, $eZ0we.t)('Scrivi almeno qualche parola sul problema (minimo {n} caratteri).', {
            n: $381bf416ae3d8c1c$var$LOW_RATING_MIN_COMMENT_LENGTH
        });
        return;
    }
    $381bf416ae3d8c1c$var$modalElements.submit.disabled = true;
    $381bf416ae3d8c1c$var$modalElements.status.textContent = (0, $eZ0we.t)('Salvataggio in corso...');
    try {
        await $381bf416ae3d8c1c$var$saveReview($381bf416ae3d8c1c$var$activeWidget, {
            status: 'completed'
        });
        $381bf416ae3d8c1c$var$setStatus($381bf416ae3d8c1c$var$activeWidget, (0, $eZ0we.t)('Grazie, recensione salvata.'), 'success');
        $381bf416ae3d8c1c$var$modalElements.status.textContent = (0, $eZ0we.t)('Recensione salvata. Grazie!');
        window.setTimeout($381bf416ae3d8c1c$var$closeModal, 650);
    } catch (error) {
        console.warn('Salvataggio recensione fallito', error);
        $381bf416ae3d8c1c$var$modalElements.status.textContent = (0, $eZ0we.t)('Non siamo riusciti a salvare la recensione. Riprova tra poco.');
    } finally{
        $381bf416ae3d8c1c$var$updateSubmitState();
    }
}
async function $381bf416ae3d8c1c$var$hydrateExistingReview(widget) {
    const snapshot = await widget.firestore.getDoc(widget.docRef);
    if (!snapshot.exists()) return;
    const data = snapshot.data();
    const rating = $381bf416ae3d8c1c$var$clampRating(data.rating);
    if (rating) {
        $381bf416ae3d8c1c$var$updateStars(widget, rating);
        widget.savedRating = rating;
    }
    widget.comment = typeof data.comment === 'string' ? data.comment : '';
    widget.displayName = typeof data.displayName === 'string' ? data.displayName : '';
    widget.hasExistingReview = true;
    $381bf416ae3d8c1c$var$setStatus(widget, (0, $eZ0we.t)("Hai gi\xe0 lasciato un voto. Puoi aggiornarlo quando vuoi."), 'success');
}
// Aggancia la logica recensioni a un container che ha gia' le stelline nel markup.
// Vale sia per il widget generato da buildWidget() sia per markup statico come la
// slide della promo card: gating, modale e salvataggio restano gli stessi.
async function $381bf416ae3d8c1c$var$setupWidget(container) {
    const toolSlug = container.dataset.toolSlug?.trim();
    const toolName = container.dataset.toolName || toolSlug;
    if (!toolSlug) return null;
    const widget = {
        container: container,
        toolSlug: toolSlug,
        toolName: toolName,
        rating: 0,
        savedRating: 0,
        pendingLowRating: false,
        comment: '',
        displayName: '',
        hasExistingReview: false,
        starButtons: Array.from(container.querySelectorAll('.tool-review__star')),
        dismissButton: container.querySelector('.tool-review__dismiss'),
        statusEl: container.querySelector('.tool-review__status'),
        docRef: null,
        clientIdHash: null,
        clientIdSource: null
    };
    widget.starButtons.forEach((button)=>{
        button.addEventListener('click', ()=>{
            $381bf416ae3d8c1c$var$handleStarClick(widget, button.dataset.rating);
        });
    });
    widget.dismissButton?.addEventListener('click', ()=>{
        $381bf416ae3d8c1c$var$dismissWidget(widget);
    });
    // Firestore si collega solo quando l'utente si avvicina al widget: cosi' la
    // pagina non scarica l'SDK per un widget che la maggior parte non tocca.
    widget.connect = ()=>{
        if (!widget.connectPromise) widget.connectPromise = $381bf416ae3d8c1c$var$connectWidget(widget);
        return widget.connectPromise;
    };
    [
        'pointerenter',
        'focusin',
        'touchstart'
    ].forEach((eventName)=>{
        container.addEventListener(eventName, ()=>{
            widget.connect();
        }, {
            once: true,
            passive: true
        });
    });
    return widget;
}
async function $381bf416ae3d8c1c$var$connectWidget(widget) {
    try {
        const { clientIdHash: clientIdHash, source: source } = await $381bf416ae3d8c1c$var$getClientIdentity();
        const { db: db, firestore: firestore } = await $381bf416ae3d8c1c$var$getDb();
        const documentId = await $381bf416ae3d8c1c$var$sha256(`${window.location.origin}:${widget.toolSlug}:${clientIdHash}`);
        widget.clientIdHash = clientIdHash;
        widget.clientIdSource = source;
        widget.firestore = firestore;
        widget.docRef = firestore.doc(db, $381bf416ae3d8c1c$var$COLLECTION_NAME, documentId);
    } catch (error) {
        console.warn('Inizializzazione recensioni tool fallita', error);
        $381bf416ae3d8c1c$var$setStatus(widget, (0, $eZ0we.t)('Recensioni temporaneamente non disponibili.'), 'error');
        widget.starButtons.forEach((button)=>{
            button.disabled = true;
        });
        return false;
    }
    try {
        await $381bf416ae3d8c1c$var$hydrateExistingReview(widget);
    } catch (error) {
        console.warn('Recensione esistente non leggibile', error);
        $381bf416ae3d8c1c$var$setStatus(widget, '', '');
    }
    return true;
}
async function $381bf416ae3d8c1c$var$initWidget(container) {
    const toolSlug = container.dataset.toolSlug;
    const ignoreDismiss = container.dataset.toolReviewIgnoreDismiss === 'true';
    if (!toolSlug) return;
    if (!ignoreDismiss && $381bf416ae3d8c1c$var$isDismissed(toolSlug)) {
        container.hidden = true;
        return;
    }
    $381bf416ae3d8c1c$var$buildWidget(container);
    await $381bf416ae3d8c1c$var$setupWidget(container);
}
async function $381bf416ae3d8c1c$export$39d9eef7aef411a(container) {
    if (!container || container.dataset.toolReviewReady === 'true') return null;
    container.dataset.toolReviewReady = 'true';
    return $381bf416ae3d8c1c$var$setupWidget(container);
}
function $381bf416ae3d8c1c$export$3c7f094803ce8e2b(root = document) {
    const containers = [];
    if (root instanceof Element && root.matches('[data-tool-review]:not([data-tool-review-ready])')) containers.push(root);
    root.querySelectorAll('[data-tool-review]:not([data-tool-review-ready])').forEach((container)=>{
        containers.push(container);
    });
    containers.forEach((container)=>{
        if (container.closest('.promo-card-container')) return;
        container.dataset.toolReviewReady = 'true';
        $381bf416ae3d8c1c$var$initWidget(container);
    });
}

});
parcelRegister("cet9q", function(module, exports) {
module.exports = Promise.all([
    import("gyHl0"),
    import("eF1tK")
]).then(()=>parcelRequire('ilpIi'));

});

parcelRegister("gQnFK", function(module, exports) {
module.exports = Promise.all([
    import("gyHl0"),
    import("jYu4x")
]).then(()=>parcelRequire('4QApW'));

});



//# sourceMappingURL=compound-interest-calculator.84e41aed.js.map
